import axios from '@/axios'

class DashboardDataService {
  async getAllDashboardData(): Promise<any> {
    return axios.get('/dashboard/getAll')
  }
}
export default new DashboardDataService()